import { useMemo } from "react"

import { useTranslation } from "@bounce/i18n"

import type { CityData } from "../../../../libs/bounce/cities"
import { getCityUrlPath } from "../../../../libs/router"
import type { Breadcrumb } from "../../../../types"

export const useBreadcrumbs = ({ city }: { city: CityData }): Breadcrumb[] => {
  const {
    t,
    i18n: { language },
  } = useTranslation("marketing-ls-city")

  const breadcrumbs = useMemo(
    () => [
      {
        id: "bounce",
        name: "Bounce",
        href: "/",
      },
      {
        id: "luggageStorage",
        name: t("page.place.breadcrumbs.luggageStorage", "Luggage Storage"),
        href: "/cities",
      },
      {
        id: "city",
        name: city.translatedName,
        href: getCityUrlPath({ language, city }),
      },
    ],
    [t, city, language],
  )

  return breadcrumbs
}
